module.exports = __webpack_public_path__ + "img/check_box_rounded.ed995da0.png";